// For handling click on ".Custom_search .theme-icon"
document.querySelectorAll('.Custom_search .theme-icon').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('predictive-search').forEach(function(predictiveSearch) {
            predictiveSearch.style.display = 'block'; // Show predictive search
        });
    });
});

// For handling click on ".icon_close"
document.querySelectorAll('.icon_close').forEach(function(element) {
    element.addEventListener('click', function() {
        document.querySelectorAll('predictive-search').forEach(function(predictiveSearch) {
            predictiveSearch.style.display = 'none'; // Hide predictive search
        });
    });
});



// class CurrencyConverter extends HTMLElement {
//     constructor() {
//         super();     
//     }

//     connectedCallback() {
//         this.priceMax = this.getAttribute("data-pricemax");
//         this.cartPrice = this.getAttribute("data-cartprice");
//         this.convertCurrency();          
//     }

//     convertCurrency() {
//         if (!window.Shopify || !window.Shopify.currency || !window.Shopify.currency.rate) {
//             console.warn('Shopify currency rates are not available.');
//             return;
//         }
     
//         const rate = window.Shopify.currency.rate;
//         const values = this.querySelectorAll('.currency-value');
//         const priceCountry = Math.round(this.priceMax * rate)
//         const freePrice = Math.round((priceCountry - this.cartPrice) / 100)
//         console.log("freeprice", freePrice);
//       if (freePrice > 0){
//         values.forEach(span => {
//             const originalValue = parseFloat(span.textContent.replace(/[^0-9.]/g, ''));
//             if (!isNaN(originalValue)) {
//                 const convertedValue = freePrice
//                 span.textContent = `${convertedValue}`;
//             }
//         });
//       }
//     }
// }

// customElements.define('currency-converter', CurrencyConverter);



//Home page Learn more and Learn less button js


$('.certification-section-wrapper-item-icon-btn a').on('click', function(event){
  event.preventDefault();
  
  var button = $(this);
  var content = button.closest('.certification-section-wrapper-item')
                      .find('.certification-section-wrapper-item-icon-content');
  
  content.slideToggle(250, function() {
    if (content.is(':visible')) {
      button.text('Show Less');
    } else {
      button.text('Show More');
    }
  });
});


$(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
        $('#return-to-top').fadeIn(200);    // Fade in the arrow
    } else {
        $('#return-to-top').fadeOut(200);   // Else fade out the arrow
    }
});
$('#return-to-top').click(function() {      // When arrow is clicked
    $('body,html').animate({
        scrollTop : 0                       // Scroll to top of body
    }, 500);
});